
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import bgImage from '../../../image/loginBack.png';
import bgImageE from '../../../image/loginBackE.png';

export const TableBaseStyle = makeStyles(
  createStyles({
    loginContainer: {
      background: '#f0f0f0',
      backgroundImage: `url(${bgImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      height: 'calc(100vh - 12px)',
    },
    loginContainerE: {
      background: '#f0f0f0',
      backgroundImage: `url(${bgImageE})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      height: 'calc(100vh - 12px)',
    },
    systemTitle: {
      fontSize: '36pt',
      textAlign: 'center',
    },
    entryContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '280px',
      alignItems: 'center',
      justifyContent: 'flexStart',
    },
    entryRow: {
      display: 'flex',
      justifyContent: 'center',
      margin: '4px',
    },
    entryLabel: {
      width: '100px',
    },
    entry: {
      background: 'white',
      verticalAlign: 'center',
    },
    loginButton: {
      margin: '16px',
      width: '200px',
      background: 'white',
    },
    twoPasswordButton: {
      margin: '16px',
      width: '140px',
      background: 'white',
    },
    twoPasswordLabel: {
      width: '220px',
      textAlign: 'left',
    },
    messageLabel: {
      width: '320px',
      textAlign: 'left',
    },
    versionLabel: {
      position: 'fixed',
      bottom: 10,
      right: 10,
      backgroundColor: 'transparent',
      color: 'black',
      padding: '5px 10px',
      borderRadius: 4,
      fontSize: 12,
      zIndex: 1000,
    },
  })
);